import type { Reducer } from "@reduxjs/toolkit";
import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import * as AppStructureActions from "./actions";
import type { IAppStructureStoreState } from "./types";

export type AppStructureAction = ActionType<typeof AppStructureActions>;

const initialState: IAppStructureStoreState = {
  structureTreeHasError: false,
  structureTreeIsFetching: false,
  structureTree: []
};

const appStructureReducer: Reducer<IAppStructureStoreState, AppStructureAction> = (state = initialState, action: AppStructureAction) => {
  switch (action.type) {
    case getType(AppStructureActions.fetchAppStructureStart):
      return { ...state, isFetching: true };

    case getType(AppStructureActions.fetchAppStructureSuccess):
      return {
        ...state,
        isFetching: false,
        structureTree: action.payload
      };

    case getType(AppStructureActions.fetchAppStructureFail):
      return { ...state, structureTreeIsFetching: false, structureTreeHasError: true };

    default:
      return state;
  }
};

export default appStructureReducer;
